export const APPROVED_LESSON_TAGS = [
  { slug: "philosophy", label: "Philosophy", group: "Humanities", sortOrder: 10 },
  { slug: "history", label: "History", group: "Humanities", sortOrder: 20 },
  { slug: "christianity", label: "Christianity", group: "Spirituality", sortOrder: 30 },
  { slug: "psychology", label: "Psychology", group: "Humanities", sortOrder: 40 },
  { slug: "programming", label: "Programming", group: "Technology", sortOrder: 50 },
  { slug: "computer-science", label: "Computer Science", group: "Technology", sortOrder: 60 },
  { slug: "mathematics", label: "Mathematics", group: "Science", sortOrder: 70 },
  { slug: "science", label: "Science", group: "Science", sortOrder: 80 },
  { slug: "economics", label: "Economics", group: "Society", sortOrder: 90 },
  { slug: "art", label: "Art", group: "Humanities", sortOrder: 100 },
  { slug: "spirituality", label: "Spirituality", group: "Spirituality", sortOrder: 110 },
];

export const TUTORIAL_TAG_FALLBACK_COUNTS = {
  history: 10,
  "computer-science": 7,
  philosophy: 5,
  science: 4,
  programming: 3,
  christianity: 2,
  psychology: 2,
  mathematics: 2,
  art: 1,
  economics: 1,
  spirituality: 1,
};

export const getFallbackTutorialTags = () =>
  APPROVED_LESSON_TAGS.filter(
    (tag) => TUTORIAL_TAG_FALLBACK_COUNTS[tag.slug],
  )
    .map((tag) => ({
      ...tag,
      count: TUTORIAL_TAG_FALLBACK_COUNTS[tag.slug],
    }))
    .sort((left, right) => {
      const countDiff = right.count - left.count;
      return countDiff || left.sortOrder - right.sortOrder;
    });
